import CrudApiClient from './crudapiclient';
import { GATEWAY_API_URL } from '@admin-panel/config/env';
import { MetaQuery } from '@refinedev/core';
import { axiosInstance } from './axios';

interface CollectionData {
  name: string;
  type: 'QUERY_BASED' | 'MANUAL';
  sortBy: string;
  isActive: boolean;
  queryFilters: Record<string, any>;
}

class CollectionApiClient extends CrudApiClient {
  constructor() {
    super(GATEWAY_API_URL + '/catalog/collection');
  }

  async updateById<T = any>(
    id: string | number,
    data: Partial<T>,
    meta: MetaQuery | undefined,
  ): Promise<T> {
    try {
      const response = await axiosInstance.put(`${this.baseURL}/${id}`, data, {
        headers: {
          'x-lk-orgid': 'lyskraft',
          'x-lk-portalcode': 'pos',
          'x-lk-scid': '1',
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error updating collection:', error);
      throw error;
    }
  }

  async deleteById<T = any>(id: string | number, meta: MetaQuery | undefined): Promise<T> {
    try {
      const response = await axiosInstance.delete(`${this.baseURL}/${id}`, {
        headers: {
          'x-lk-orgid': 'lyskraft',
          'x-lk-portalcode': 'pos',
          'x-lk-scid': '1',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error deleting collection:', error);
      throw error;
    }
  }

  // Override the transform methods to add custom headers
  async create<T = any>(payload: Partial<T>, meta: MetaQuery | undefined): Promise<T> {
    try {
      const response = await axiosInstance.post(`${this.baseURL}` + '/', payload, {
        headers: {
          'x-lk-orgid': 'lyskraft',
          'x-lk-portalcode': 'pos',
          'x-lk-scid': '1',
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error creating collection:', error);
      throw error;
    }
  }

  // Method to get facets for filtering
  async getFacets(): Promise<any> {
    try {
      const response = await axiosInstance.post(
        GATEWAY_API_URL + '/search/styles',
        {
          searchType: 'FREETEXT',
          text: '',
          selectedFacets: {},
          page: 1,
          size: 1,
        },
        {
          headers: {
            'x-lk-orgid': 'lyskraft',
            'x-lk-portalcode': 'pos',
            'x-lk-scid': '1',
            'Content-Type': 'application/json',
          },
        },
      );
      return response.data.data.facets || [];
    } catch (error) {
      console.error('Error fetching facets:', error);
      throw error;
    }
  }
}

export default CollectionApiClient;
